export default "__VITE_ASSET__c600908c__"